"use strict";
exports.__esModule = true;
exports.EMBED_SETTINGS_AUTOPAY_TOGGLE_CONFIRM_AUTOPAY = exports.EMBED_SETTINGS_AUTOPAY_TOGGLE_CONFIRM_EPISODIC = exports.EMBED_SETTINGS_AUTOPAY_TOGGLE = exports.EMBED_SETTINGS = void 0;
exports.EMBED_SETTINGS = {
    HEADER: 'Settings',
    BACK: 'Back'
};
exports.EMBED_SETTINGS_AUTOPAY_TOGGLE = {
    HEADER: 'Rent autopay',
    BODY_AUTOPAY: 'Flex will attempt to pay your rent bill for {{ bpMonth }} and every following month. Turn off to pause rent payments.',
    BODY_EPISODIC: 'Turn on to resume service starting with your rent bill for {{ bpMonth }}.'
};
exports.EMBED_SETTINGS_AUTOPAY_TOGGLE_CONFIRM_EPISODIC = {
    HEADER: 'Turn off rent autopay?',
    BODY_1: 'Starting with your {{ bpMonth }} bill, Flex will not automatically pay or report your rent.',
    BODY_2: 'Your credit line will remain open, so you can continue to use Flex to pay your rent manually. You can also turn rent autopay back on at any time.',
    NOTICE: 'Your membership fee will continue to be charged on the 15th of each month',
    CANCEL: 'Never mind',
    CTA: 'Turn off'
};
exports.EMBED_SETTINGS_AUTOPAY_TOGGLE_CONFIRM_AUTOPAY = {
    HEADER: 'Turn on rent autopay?',
    BODY: 'Turn on to have Flex start paying your rent bill each month.',
    NOTICE: 'Rent autopay will begin with your {{ bpMonth }} rent bill',
    CANCEL: 'Never mind',
    CTA: 'Turn on'
};
